// extracted by extract-css-chunks-webpack-plugin
module.exports = {"searchBarWrapper":"_29kEr3","searchPageBar":"_30WFV-","searchResult":"_15Cvyu","spinner":"_19-Fpb","searchResultText":"_2vgWoG"};